import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetQualitativeQuestion state domain
 */

const selectWidgetQualitativeQuestionDomain = (state) =>
  state.get("widgetQualitativeQuestion", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoadingQuestions = () =>
  createSelector(selectWidgetQualitativeQuestionDomain, (state) =>
    state.get("isLoadingQuestions")
  )

export const makeSelectQuestions = () =>
  createSelector(selectWidgetQualitativeQuestionDomain, (state) =>
    state.get("questions")
  )

export const makeSelectOnlyQuestions = () =>
  createSelector(selectWidgetQualitativeQuestionDomain, (state) =>
    state.get("onlyQuestions")
  )
/**
 * Default selector used by WidgetQualitativeQuestion
 */

const makeSelectWidgetQualitativeQuestion = () =>
  createSelector(selectWidgetQualitativeQuestionDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetQualitativeQuestion
export { selectWidgetQualitativeQuestionDomain }
